module.exports = __webpack_public_path__ + "static/media/referral-landing-background.730aa08e.png";